import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from '@/util/BASEAPI';


@Component({
})
export default class SANewsCard extends Mixins(BASEComponentVue) {

    @Prop({
        type: Object,
        default: () => { return { "id": "0" } }
    })
    news!: BASEAPI.News;

    @Prop({
        type: String,
        default: ""
    })
    openDateString!: string;
}
